import { LocalizedText } from '@mews/framework';
import { Card } from '@mews-commander/ui';
import { IconButton, IconName } from '@optimus-web/core';
import { HeaderButtonWrapper } from './style';

const DismissibleFormWrapper = ({ headerButtonTextKey, onClose, children, opened }: $TSFixMe) =>
    opened ? (
        <>
            <HeaderButtonWrapper>
                <IconButton icon={IconName.ArrowLeft} onClick={onClose} variant="ghost" type="submit" />
                <LocalizedText textKey={headerButtonTextKey} />
            </HeaderButtonWrapper>
            <Card>{children}</Card>
        </>
    ) : null;

export default DismissibleFormWrapper;
